module.exports = __webpack_public_path__ + "img/20200117160012360截图20200117111824718.40c2434e.jpg";